import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, Camera, Heart } from 'lucide-react';

const galleryImages = [
  { id: 1, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhlDrKleD_h4jMjZy9nZ96UUiZcSZcYVuuaVCCer0UlDUa77fjm7GwGfq2dAqmH8LDSJi2EJ1vn9uvWSSQiFlh34bKelyqpglvAguABeecgAnjGflxoyTX89vInouofVNSDr-khldCcmBptK7YwAYuLqozVH8ltgUKSA9xgyKfFtAau4Zg6PwyZRtdeOPBM/s320/573658533_18085540022301075_6596113588414898331_n..jpg', alt: 'Fofinha' },
  { id: 2, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhIeXVVHpi7fH3skLd1GmSB3SQDMuEKtA9l_4RUa4SCV4l169S5poDn59dJpgpyrOkYckVDyUYNclnOzMB0TL2rauUBYq8tUEe7YtO2sGzuxeUj0YIsLQdwUihTI5NZ2VI12PuX9I-LMEU6ARjlaMC4rSU0C0pDY6muvHtzVYHtCf_Q2z-AZmfMvMLcbGUg/s320/572584433_18085529360301075_1639689398509934660_n..jpg', alt: 'Baco' },
  { id: 3, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh-FYmhjlOEsVlxBY6QEvc6xq6GdcNB9pdSKFAj9O5QgRoVvdXdZ2F7f7WAuPCfzhaqApH6r2VxOpCNxi3j_2f8ud5l11DjYpmOps9keArsIIWU6vpmSBVyvy3Na0jYcKluA84QFk_8Jm6NtjhULeWY7VQ_zQAC6wAnwaIeMPEUNSKgUFJMSPQEqUv2-3IO/s320/572579615_18085540004301075_4917712219351205351_n..jpg', alt: 'Belinha' },
  { id: 4, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjCx8jEWm9t0WaEM6w9BjSOSuFrPaGFcY4MhObqW_nGMP-Qtrn4VbWFPNR57rDhtFIN2xHV-eV4l6dzr5iKwZy8c5AePajYzZXXoVababmTMx7POC1gCFvpYAaPSHJiig2Lz099RLnO2NfbYU4RqhEsclgU_Br7wMX5cipK0Ws2h3SHCIFuv9uXi9wMLxqM/s320/572443846_18085540055301075_8224039869896009853_n..jpg', alt: 'Tobby' },
  { id: 5, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEit67mXAfw7CfcosbSBpG5vw2-bcRTacgqLKoLKG1f2oPYPKMj4bAnGNoo_PCx1LbsGe0IR3avrfrPyTqFUK2uOcmqisAwQFINMmyzPWiypnjCiBRZgDk5N2Rq0RFiwUtvfjKy3Pi08JyrbOWP14e26ed1NtK3Bnupmb6FY-OqWk_3ho5F_LvpaSUOGi41D/s320/572122817_18085540031301075_3040560816623841388_n..jpg', alt: 'Tobby' },
  { id: 6, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjePut5nkx55Ivb-2fo9rrqbDxSTnIVe4hO23yvOoUxbdTFxcNt5T-HVXcmZIocbxZU0qGTgRhvq1Gk2fJghYRVSusjMPST3GqH_ajc2BOVPovXSUk8iu9WiFX1B1b4IfZN2UaUqHH8oDh-KN4I2T64qFyNQujGVW4llIVud-ynl6wK99YpHNuZO-5lNKUv/s320/571814630_18085529333301075_6684300179406073949_n..jpg', alt: 'Ginza' },
  { id: 7, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhP7yjJb-M43aKrqCSz_lQqvm9xWxrsx99e3m23rri3360LDmj5VnqQMzpIHB_NsZKZ_kWXL_TVbE6VFTat2EiIgyQHYBXQgJyAqvKaWHVsqEQvqNK2YrPlpjdwb3G9nuSyzQFht6McSfRmiSdulKc9CxAcTDfyxRE0yPE9J70lXIC3cJiufKPhMNp12RMO/s320/571808352_18085529369301075_5015706502261341408_n..jpg', alt: 'Cookie' },
  { id: 8, src: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjh32vD05rbCpQl28sw3TYqR_y9zL28spNHpcMcJGVWdZDYRq3BOtyuDqsXifTZ0Rm1nslFVA99VdbeNcskkG8X0DAajh6cJ2hHg45Fqjt8d6rBPTOIQr9_jErsqDryxl5XZyTdNlt-yYx9YJR4nzZcfpPrf_b5hHEZHAv4k4fttYz-9bzttFhp0Do_hLh3/s320/571734838_18085540064301075_8181094414520081777_n..jpg', alt: 'Alfredinho' },
];

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(galleryImages[index]);
  };

  const closeLightbox = () => setSelectedImage(null);

  const goToPrevious = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === 0 ? galleryImages.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === galleryImages.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(galleryImages[newIndex]);
  };

  return (
    <section id="galeria" className="py-20 bg-gray-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Personalizado */}
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="bg-yellow-100 text-yellow-700 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2 mb-4">
            <Camera size={16} /> Galeria de Fotos
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            Nossos <span className="text-yellow-500">Clientes Vips</span>
          </h2>
          <div className="w-24 h-1.5 bg-yellow-400 mx-auto rounded-full" />
        </motion.div>

        {/* Grid com Imagens Padronizadas e Sombras */}
        <motion.div 
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
          layout
        >
          {galleryImages.map((image, index) => (
            <motion.div
              key={image.id}
              className="relative group cursor-pointer aspect-square rounded-3xl overflow-hidden bg-white shadow-xl hover:shadow-2xl transition-all duration-300 border-4 border-white"
              whileHover={{ y: -10 }}
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              
              {/* Overlay Personalizado */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <motion.div 
                  initial={{ y: 20 }} 
                  whileInView={{ y: 0 }}
                  className="flex items-center gap-2 text-white"
                >
                  <Heart size={18} className="fill-yellow-400 text-yellow-400" />
                  <span className="font-bold text-lg italic">{image.alt}</span>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Lightbox Melhorado */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeLightbox}
          >
            <button className="absolute top-6 right-6 p-2 bg-white/10 hover:bg-red-500 rounded-full text-white transition-all z-50" onClick={closeLightbox}>
              <X size={32} />
            </button>

            <button className="absolute left-4 p-4 text-white hover:text-yellow-400 transition-colors" onClick={goToPrevious}>
              <ChevronLeft size={48} />
            </button>

            <motion.div 
              className="relative max-w-4xl w-full flex flex-col items-center"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
            >
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="max-h-[80vh] w-auto rounded-2xl shadow-2xl border-2 border-white/20"
              />
              <p className="text-white mt-4 text-2xl font-nunito font-bold italic">
                ✨ {selectedImage.alt} ✨
              </p>
            </motion.div>

            <button className="absolute right-4 p-4 text-white hover:text-yellow-400 transition-colors" onClick={goToNext}>
              <ChevronRight size={48} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};